export const FieldType = {
  CHECKBOX: 0,
  NUMBER_FIELD: 1,
  TEXT_FIELD: 2,
  DROPDOWN: 3,
};
